import { render, staticRenderFns } from "./SensorPage.vue?vue&type=template&id=6c870478&scoped=true&"
import script from "./SensorPage.vue?vue&type=script&lang=js&"
export * from "./SensorPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c870478",
  null
  
)

export default component.exports